import { styled, ButtonProps } from "@mui/material";
import { LoadingButton as MuiButton } from "@mui/lab";
const StyledButton = styled(MuiButton)<ButtonProps>(({ theme }) => ({
	// color: theme.palette.getContrastText(purple[500]),
	// backgroundColor: purple[500],
	// "&:hover": {
	// 	backgroundColor: purple[700],
	// },
}));

export const LoadingButton = (props: any) => {
	const {
		name = "button",
		variant = "contained",
		disabled,
		color,
		onClick,
		size = "large",
		startIcon,
		endIcon,
		loading = false,
		loadingPosition = "start",
	} = props;
	return (
		<StyledButton
			variant={variant}
			disabled={disabled}
			color={color}
			onClick={onClick}
			size={size}
			// Icon with button props...
			startIcon={startIcon}
			endIcon={endIcon}
			// Loading button props...
			loading={loading}
			loadingPosition={loadingPosition}
			{...props}
		>
			{name}
		</StyledButton>
	);
};